import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import { Button, Card, CardBody, Col, Row, Badge } from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import axios from "axios";
import {API_URL} from "../../constants/constants";

const TopPerformers = props => {
  const dispatch = useDispatch()
  const [customerReports, setCustomerReports] = useState([])
  const selectRow = {
    mode: "checkbox",
  }
  useEffect(() => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/customer-reports?is_dashboard=1`,
    })
        .then(function (response) {
          let data = response?.data?.data.sort(function (a, b) {
            return b.total_stake - a.total_stake
          })
          setCustomerReports(data)
        })
        .catch(function (response) {
          //handle error
          //  showErrorMessages(response)
        })
  }, [])

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [orderList, setOrderList] = useState([])
  const [isEdit, setIsEdit] = useState(false)

  //pagination customization
  const pageOptions = {
    sizePerPage: 6,
    totalSize: customerReports.length,
    custom: true,
  }
  const { SearchBar } = Search

  // const toggleModal = () => {
  //   setModal1(!modal1)
  // }
  const toggleViewModal = () => setModal1(!modal1)

  const EcommerceOrderColumns = toggleModal => [
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "end_user",
      text: "User",
      sort: true,
    },
    {
      dataField: "bets",
      text: "Bets",
      sort: true,
    },
    {
      dataField: "total_stake",
      text: "Staked",
      sort: true,
      formatter: (cell, row) => <>{Number(row.total_stake.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "Net Payout",
      text: "Net Payout",
      sort: true,
      formatter: (cell, row) => <>{Number(row.net_payout.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "GGR Ratio",
      text: "GGR Ratio",
      sort: true,
      formatter: (cell, row) => <>{row.GGR_ratio.toFixed(2)+'%'}</>,
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]


  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">TopPerformers</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={EcommerceOrderColumns(toggle)}
            data={customerReports}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={customerReports}
                columns={EcommerceOrderColumns(toggle)}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}



export default withRouter(TopPerformers)
